export default __webpack_public_path__ + "static/media/GoogleplayIcon.24d9cb95.svg";